import { CardComponentProps } from "@~/types/types";
import styles from "./PreOrderMessages.module.scss";

export function PreOrderMessages({
  product,
}: Pick<CardComponentProps, "product">) {
  const availableToOrderFromMessage =
    product.availability?.futureAvailability?.availableToOrderFromMessage;
  const streetDateMessage = product.availability?.preOrder?.streetDateMessage;

  if (!availableToOrderFromMessage && !streetDateMessage) {
    return null;
  }

  return (
    <div data-component="pcl-PreOrderMessage">
      {availableToOrderFromMessage && (
        <p
          className={styles.preOrderMessage}
          data-testid="availableToOrder-message"
        >
          {availableToOrderFromMessage}
        </p>
      )}

      {streetDateMessage && (
        <p className={styles.preOrderMessage} data-testid="streetDate-message">
          {streetDateMessage}
        </p>
      )}
    </div>
  );
}
